import script from "./EOCButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./EOCButton.vue?vue&type=script&setup=true&lang=ts"

import "./EOCButton.vue?vue&type=style&index=0&id=070985f6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-070985f6"]])

export default __exports__